// 데이터 모양 — v0.3 Model.kt 필드 이름 그대로 + 동기화 필드(DESIGN §2)
export const ENTITIES = ["staff", "students", "items", "sessions", "warns", "settings"] as const;
export type Entity = (typeof ENTITIES)[number];

export type SyncFields = { id: string; version?: number; updatedAt?: number; updatedBy?: string; deleted?: number };

export type Staff = SyncFields & { name: string; admin: boolean };
export type Slot = { dow: number; time: string };
export type Student = SyncFields & { name: string; school: string; phone: string; memo: string; color: number; slots: Slot[] };
export type Item = SyncFields & {
  studentId: string; week: string; title: string; done: boolean;
  createdBy: string; createdAt: number; doneAt: number | null; doneBy: string | null; doneSession: string | null;
};
export const St = { PLAN: "예정", DONE: "완료", PARTIAL: "미완료", NOSHOW: "노쇼" } as const;
export type Status = (typeof St)[keyof typeof St];
export type Session = SyncFields & {
  studentId: string; date: string; time: string; status: Status; late: boolean;
  createdBy: string; createdAt: number; closedBy: string | null; note: string;
};
export type Warn = SyncFields & {
  studentId: string; type: string; date: string; note: string; createdBy: string; createdAt: number; sessionId: string | null;
};
export type Settings = SyncFields & { warnThreshold: number; notify: boolean; notifyBefore: number; presets: string[]; times: string[] };

export type Row = SyncFields & Record<string, unknown>;

export const DEFAULT_TIMES = [...Array.from({ length: 9 }, (_, i) => i + 13).flatMap((h) => [`${h}:00`, `${h}:30`]), "22:00"];
export const DEFAULT_SETTINGS: Settings = {
  id: "main", warnThreshold: 3, notify: true, notifyBefore: 10, times: DEFAULT_TIMES,
  presets: ["교과서 1차(빈칸조합)", "교과서 2차(손필기)", "부교재 1차(빈칸조합)", "부교재 2차(손필기)", "단어 테스트", "문법 테스트", "서술형 테스트", "모의고사 오답"],
};

export const WARN_TYPES = ["수업 지각", "클리닉 지각", "숙제 미완료", "노쇼", "기타"] as const;
